import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, Col, Row } from 'reactstrap'
import { RowPrice, RowPriceOrange, RowProdDet, RowProdTitle, RowStarReviews, RowProdDesc, RowButton } from '../../../StyledComponents'
import { Star } from 'react-feather'

const RowProducts = (props) => {
  const { products } = props;

  return (
    <>
      <div className='w-100 flex'>
        <Row className='m-0'>
          {products.map((item, index) => (
            <Col xl="12" lg="12" md="12" sm="12" xs="12" key={index}>
              <Row>
                <Col xl='3' lg='3' md='3' sm='12' xs='12' >
                  <div className="item-img mx-auto my-md-0 ">
                    <Link>
                      <img className="img-fluid" src={item.image} alt={item.name} style={{ maxWidth: '100%', width: '250px' }} />
                    </Link>
                  </div>
                </Col>
                <Col xl='9' lg='9' md='9' sm='12' xs='12' >
                  <RowProdDet>
                    <RowProdTitle>{item.name}</RowProdTitle>

                    <div className="d-flex align-items-center ">
                      <RowPriceOrange>${item.price}</RowPriceOrange> &nbsp;
                      <RowPrice>
                        <strike>${item.originalPrice}</strike>
                      </RowPrice>
                    </div>

                    <div className="d-flex align-items-center">
                      <Star size={18} color="orange" fill="orange" />
                      &nbsp;
                      <RowStarReviews>{item.rating} ({item.reviews})</RowStarReviews>
                    </div>

                    <RowProdDesc>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing.
                    </RowProdDesc>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '11px', }}>
                      <RowButton type="button" block
                        color='light-primary'
                        style={{
                          marginRight: '0.5rem',
                          backgroundColor: '#FBBD34',
                        }}>
                        ADD TO CART</RowButton>
                      <RowButton type="button" block
                        color='light-primary'
                        style={{
                          backgroundColor: '#41B8E4',
                        }}>BUY NOW</RowButton>
                    </div>
                  </RowProdDet>
                </Col>
              </Row>

              <br />
            </Col>
          ))}
        </Row>
      </div>
    </>
  )
}

export default RowProducts